export const productSearchSortValues = [
  {
    'value': 'default',
    'display': 'Relevance'
  },
  {
    'value': '^Product Code',
    'display': 'Product ID, Ascending',
    'displayedColumns': 'productCode',
    'direction': 'asc'
  },
  {
    'value': '$Product Code',
    'display': 'Product ID, Descending',
    'displayedColumns': 'productCode',
    'direction': 'desc'
  },
  {
    'value': '^root_productProvenances_productType',
    'display': 'Product Type, Ascending',
    'displayedColumns': 'productType',
    'direction': 'asc'
  },
  {
    'value': '$root_productProvenances_productType',
    'display': 'Product Type, Descending',
    'displayedColumns': 'productType',
    'direction': 'desc'
  },
  {
    'value': '^root_productProvenances_productStatus',
    'display': 'Status, Ascending',
    'displayedColumns': 'status',
    'direction': 'asc'
  },
  {
    'value': '$root_productProvenances_productStatus',
    'display': 'Status, Descending',
    'displayedColumns': 'status',
    'direction': 'desc'
  },
  {
    'value': '^Ingredient Name (Preferred)',
    'display': 'Ingredient Name, A-Z',
    'displayedColumns': 'ingredientName',
    'direction': 'asc'
  },
  {
    'value': '$Ingredient Name (Preferred)',
    'display': 'Ingredient Name, Z-A',
    'displayedColumns': 'ingredientName',
    'direction': 'desc'
  },
  {
    'value': '^root_productManufactureItems_productLots_productIngredients_ingredientType',
    'display': 'Ingredient Type, A-Z',
    'displayedColumns': 'ingredientType',
    'direction': 'asc'
  },
  {
    'value': '$root_productManufactureItems_productLots_productIngredients_ingredientType',
    'display': 'Ingredient Type, Z-A',
    'displayedColumns': 'ingredientType',
    'direction': 'desc'
  },
  {
    'value': '^root_productProvenances_productNames_productName',
    'display': 'Dosage Form, A-Z',
    'displayedColumns': 'productName',
    'direction': 'asc'
  },
  {
    'value': '$root_productProvenances_productNames_productName',
    'display': 'Dosage Form, Z-A',
    'displayedColumns': 'productName',
    'direction': 'desc'
  },
  {
    'value': '^root_productManufactureItems_dosageForm',
    'display': 'Dosage Form, A-Z',
    'displayedColumns': 'dosageName',
    'direction': 'asc'
  },
  {
    'value': '$root_productManufactureItems_dosageForm',
    'display': 'Dosage Form, Z-A',
    'displayedColumns': 'dosageName',
    'direction': 'desc'
  },
  {
    'value': '^root_productProvenances_productCompanies_companyName',
    'display': 'Labeler Name, A-Z',
    'displayedColumns': 'labelerName',
    'direction': 'asc'
  },
  {
    'value': '$root_productProvenances_productCompanies_companyName',
    'display': 'Labeler Name, Z-A',
    'displayedColumns': 'labelerName',
    'direction': 'desc'
  },
  {
    'value': '^root_productProvenances_productCompanies_companyCountry',
    'display': 'Company Country, A-Z',
    'displayedColumns': 'country',
    'direction': 'asc'
  },
  {
    'value': '$root_productProvenances_productCompanies_companyCountry',
    'display': 'Company Country, Z-A',
    'displayedColumns': 'country',
    'direction': 'desc'
  },
  {
    'value': '^Application Type Number',
    'display': 'Application Type Number, A-Z',
    'displayedColumns': 'applicationNumber',
    'direction': 'asc'
  },
  {
    'value': '$Application Type Number',
    'display': 'Application Type Number, Z-A',
    'displayedColumns': 'applicationNumber',
    'direction': 'desc'
  },
  {
    'value': '^root_creationDate',
    'display': 'Oldest Creation'
  },
  {
    'value': '$root_creationDate',
    'display': 'Newest Creation'
  },
  {
    'value': '^root_lastModifiedDate',
    'display': 'Oldest Change'
  },
  {
    'value': '$root_lastModifiedDate',
    'display': 'Newest Change'
  }
];
